 
import React from 'react';
import AdminDashboard from '../components/admin/AdminDashboard';

const AdminPage = () => {
    return (
        <div className="admin-page">
            <AdminDashboard />
        </div>
    );
};

export default AdminPage;
